
import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useEvent } from './useEvent';
import * as ActionTypes from '../actions/actionTypes'
import { SAVE_ITEM_CDS } from '../api/apiEvents';
import { CURRENT_INVOICE } from '../formSections/itemsTab/copyRepElement';



export const useMultipleMerchandiseItem=({tableName,...rest})=>{
 const {isLoading,saveForm,deleteForm}=useEvent("invoice",true)
 const dispatch = useDispatch(); 
  const AddItem = useCallback(async(callback) => {
     try{
       
        const isadditionalSupplyChainActor=tableName=="additionalSupplyChainActor"
        const response=await saveForm({
            "merchandise": {
                [`${rest.merchandiseId}`]: {
                    "invoiceId":rest.invoiceId,
                    [`${tableName}`]: [
                        isadditionalSupplyChainActor ? {aeoFlag:true}:{}
                    ]
                }
            }
        },true,SAVE_ITEM_CDS)

        if(response){
            const {id,roleId,invoiceActorRoleId}=response.invoice.merchandise[rest.merchandiseId][tableName][0]
            const payload=isadditionalSupplyChainActor ? {id,roleId,invoiceActorRoleId}:{id}
        dispatch({
            type: ActionTypes.ADD_MERCHANDISE_DOC_BY_ID,
            ids:[{...payload,...rest}],
            meta:{tableName}
        })
        callback && callback(response)
    }
     }
     catch(e){

     }
  }, [rest.invoiceId,rest.merchandiseId]);

  const deleteItem = useCallback(async(id) => {
    try{
         const response=await deleteForm( {"merchandise": {[`${rest.merchandiseId}`]: { [`${tableName}`]:[{id}]}}})
         if(response)
        dispatch({ type:ActionTypes.DELETE_MERCHANDISE_DOC_BY_ID,payload:{id,...rest},meta:{tableName:tableName}}) 
      
     }
     catch(e){

     }
 }, [rest.invoiceId,rest.merchandiseId]);

 const updateItem = useCallback((id,payload) => {
    try{
        dispatch({
            type:ActionTypes.UPDATE_MERCHANDISE_DOC_BY_ID,
            id,
            payload:{...payload,...rest},
            meta:{tableName:tableName}
        })
    }
    catch{

    }
 }, [rest]);

 const saveItem = useCallback(async(payload) => {
    let response = null
    try{
        if(tableName=="additionalSupplyChainActor") 
            payload.aeoFlag=true
            
        response = await saveForm({
            "merchandise": {
                [`${rest.merchandiseId}`]: {
                    "invoiceId":rest.invoiceId,
                    [`${tableName}`]: Array.isArray(payload) ? payload: [payload]
                }
            }
        },false,SAVE_ITEM_CDS)
    }
    catch{

    }
    return response
 }, [rest.invoiceId,rest.merchandiseId]);

    const AddCopyItem = useCallback(async (copyTo, payload) => {
        try {
            const isadditionalSupplyChainActor = tableName == "additionalSupplyChainActor"
            const response = await saveForm({
                [`${copyTo}`]: true,
                "merchandise": {
                    [`${rest.merchandiseId}`]: {
                        "invoiceId": rest.invoiceId,
                        [`${tableName}`]: [isadditionalSupplyChainActor ? { aeoFlag: true, ...payload } : { ...payload }]
                    }
                }
            }, true, SAVE_ITEM_CDS)

            if (response) {
                return response
            }
        }
        catch (e) {

        }
    }, [saveForm, rest.invoiceId, rest.merchandiseId])

    const copyData = useCallback(async (copyFor, payload) => {
        const copyTo = copyFor === CURRENT_INVOICE ? 'copyToInvoice' : 'copyToAllInvoice'
        const response = await AddCopyItem(copyTo, payload)

        if (response?.invoice) {
            dispatch({
                type: ActionTypes.COPY_TO_MASS_UPDATE_CDS,
                ids: response?.invoice?.merchandise || {},
                meta: { tableName }
            })
        }

    }, [tableName, AddCopyItem, saveForm, rest.invoiceId, rest.merchandiseId])


  return React.useMemo(()=>({
    AddItem,
    deleteItem,
    updateItem,
    saveItem,
    copyData,
    isLoading}),
    [AddItem,deleteItem,updateItem,saveItem,copyData,isLoading])
}